
import React, { PureComponent, Fragment } from "react";
import styles from "./Calculator.scss";
import { Input, Divider, Currency, Menu } from "@wg/wows-react-uikit";
import { t } from "../../../helpers/localization";
import { CurrencyType } from "@wg/wows-react-uikit/Currency";
import { Balance } from "../../../Reducers/ReducerTreasury";

import { ItemValue } from "../../UIKit/Menu/Menu";

export type IProps = {
  distributionSum: number;
  userCount: number;
  totalBalanceList: Balance;
  selectedDistributionCurrency: CurrencyType;
  treasuryMinDistributionSumm: number;

  selectDistributionCurrency: (type: CurrencyType) => void;
  setDistributionSum: (sum: number) => void;
};

import { currencyNames } from "fe2/Components/UIKit/Currency/Currency";

class Calculator extends PureComponent<IProps, any> {


  onChange = (e: React.InputEvent<EventTarget>) => {
    
    let val = e.nativeEvent.target.value;
    if (val === '') {
      val = 0;
    }
    if (val < 0) {
      val = 0;
    }
    if (isNaN(val)) {
      val = 0;
    }

    this.props.setDistributionSum(parseInt(val));
  };

  onCurrencySelect = (value: ItemValue) => {
    const cur = `${value}`;
    
    this.props.selectDistributionCurrency(cur);
  };

  render() {
    let selectedCurrency = this.props.totalBalanceList.filter(item => {
      return item.type === this.props.selectedDistributionCurrency;
    })[0];
    if (!selectedCurrency) {
      selectedCurrency = this.props.totalBalanceList[0] ? this.props.totalBalanceList[0] : { type: 'oil', amount: 0 };
    }
    const isSingle = this.props.userCount === 1;
    const totalSum = Math.round(this.props.userCount * this.props.distributionSum);
    const total = selectedCurrency.amount;
    const rest = total - totalSum;
    if (rest < 0) {
      this.props.setDistributionSum(Math.floor(total / this.props.userCount));
    }

    return <div className={styles.wrapper}>
                <div className={styles.row}>
                    <div className={styles.label}>{t('Распределяемый ресурс')}</div>
                    <div className={`${styles.resourse} ${styles.menuWrapper}`}>
                        <Menu isSmallPadding={true} items={this.props.totalBalanceList.filter(item => {
            return item.canDistribute;
          }).map(item => {
            return {
              value: item.type,
              content: currencyNames[item.type]
            };
          })} itemSelected={this.props.selectedDistributionCurrency} onItemChange={this.onCurrencySelect}>
                            <div className={styles.menuCurrencyWrapper}>
                                <Currency isBold amount={total} type={selectedCurrency.type} t={t} />
                            </div>
                        </Menu>

                    </div>
                </div>
                <Divider type={'minor'} />
                {isSingle ? <div className={styles.row}>
                        <div className={styles.label}>{t('Начислить игроку')}</div>
                        <div className={styles.resourseInput}>
                            <Input error={''} help={''} info={''} label={''} maxLength={10} placeholder={''} value={`${this.props.distributionSum}`} width={'64'} noimesupport={false} isValidating={false} isCounted={false} isInlined={false} isTextCentered={false} isFocusOn={false} isDisabled={false} t={t} onBlur={() => {}} onChange={this.onChange} onFocus={() => {}} onKeyPress={e => {}} />
                            <Currency isBold amount={0} type={selectedCurrency.type} onlyIcon t={t} />
                        </div>
                    </div> : <Fragment>
                        <div className={styles.row}>
                            <div className={styles.label}>{t('Начислить каждому игроку')}</div>
                            <div className={styles.resourseInput}>
                                <Input error={''} help={''} info={''} label={''} maxLength={10} placeholder={''} value={`${this.props.distributionSum}`} width={'64px'} noimesupport={false} isValidating={false} isCounted={false} isInlined={false} isTextCentered={false} isFocusOn={false} isDisabled={false} t={t} onBlur={() => {}} onChange={this.onChange} onFocus={() => {}} onKeyPress={e => {}} />
                                <Currency isBold amount={0} type={selectedCurrency.type} onlyIcon t={t} />
                            </div>
                        </div>
                        <div className={styles.row}>
                            <div className={styles.label}>{t('Будет распределено')}</div>
                            <div className={styles.resourse}>
                                <Currency isBold amount={totalSum} type={selectedCurrency.type} t={t} />
                            </div>
                        </div>
                    </Fragment>}

                <Divider type={'minor'} />
                <div className={styles.row}>
                    <div className={styles.label}>{t('Остаток после распределения')}</div>
                    <div className={styles.resourse}>
                        <Currency isBold amount={rest} type={selectedCurrency.type} t={t} />
                    </div>
                </div>
            </div>;
  }
}

export default Calculator;